import React from 'react';

import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import TurnSlightLeftIcon from '@mui/icons-material/TurnSlightLeft';
import TurnSlightRightIcon from '@mui/icons-material/TurnSlightRight';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import UTurnRightIcon from '@mui/icons-material/UTurnRight';
import SouthWestIcon from '@mui/icons-material/SouthWest';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import MergeIcon from '@mui/icons-material/Merge';
import RampLeftIcon from '@mui/icons-material/RampLeft';
import RampRightIcon from '@mui/icons-material/RampRight';
import DirectionsTransitIcon from '@mui/icons-material/DirectionsTransit';

import { typeManeuver } from '../enum/typeManeuver';

export const setIconManeuver = (type) => {
  switch (type) {
    case typeManeuver.kStart:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kStartRight:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kStartLeft:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kContinue:
      return (
        <ArrowUpwardIcon />
      );
    case typeManeuver.kDestination:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kDestinationLeft:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kDestinationRight:
      return (
        <TripOriginIcon />
      );
    case typeManeuver.kUturnLeft:
      return (
        <UTurnLeftIcon />
      );
    case typeManeuver.kSlightLeft:
      return (
        <TurnSlightLeftIcon />
      );
    case typeManeuver.kStayLeft:
      return (
        <SouthWestIcon />
      );
    case typeManeuver.kRampLeft:
      return (
        <RampLeftIcon />
      );
    case typeManeuver.kLeft:
      return (
        <TurnLeftIcon />
      );
    case typeManeuver.kSlightRight:
      return (
        <TurnSlightRightIcon />
      );
    case typeManeuver.kRight:
      return (
        <TurnRightIcon />
      );
    case typeManeuver.kUturnRight:
      return (
        <UTurnRightIcon />
      );
    case typeManeuver.kRampRight:
      return (
        <RampRightIcon />
      );
    case typeManeuver.kStayRight:
      return (
        <SouthEastIcon />
      );
    case typeManeuver.kMerge:
      return (
        <MergeIcon />
      );
    case typeManeuver.kTransit:
      return (
        <DirectionsTransitIcon />
      );
    default:
      return (
        <ArrowUpwardIcon />
      );
  }
};